export default {
  map: 'Mapa',
  overview: 'Visão Geral',
  devices: 'Dispositivos',
  phones: 'Rastreadores',
  geofences: 'Cercas Eletrônicas',
  alerts: 'Alertas',
  history: 'Histórico',
  reports: 'Relatórios',
  sharing: 'Links',
  users: 'Usuários',
  account: 'Configurações',
  orders: 'Pedidos',
  logout: 'Sair',
  impersonating: 'Visualizando como {name}',
  impersonating_end: 'Encerrar',
  company: 'Empresa',
  main_nav: 'Navegação principal',
  open_menu: 'Abrir menu',
  close_menu: 'Fechar menu',
  help: 'Ajuda',
  global_search: 'Busca global',
  search_placeholder: 'Buscar por dispositivo, nome, placa, pessoa, endereço...',
  alerts_unread: 'Alertas: {count} não lidos',
  brand_home: 'LOCZI Localize o que importa. Mapa',
  member: 'Membro',
}
